import { Paper, Button, SxProps, Theme } from "@mui/material";
import HourglassBottomIcon from "@mui/icons-material/HourglassBottom";
import BodyText from "../../../components/BodyText";
import SmallText from "../../../components/Smalltext";

interface Props {
  paperSx: SxProps<Theme>;
  onContactCustomerSupport: () => void;
  email: string;
  message: string | undefined;
}

const ActivationPendingView = ({
  onContactCustomerSupport: contactCustomerSupportHandler,
  paperSx,
  email,
  message,
}: Props) => (
  <Paper
    sx={{ ...paperSx, paddingTop: "40px", paddingBottom: "30px" }}
    elevation={3}
  >
    <div style={{ padding: "30px", textAlign: "center" }}>
      <HourglassBottomIcon
        style={{ width: 50, height: 50, marginBottom: 10 }}
      />
      <BodyText sx={{ fontWeight: 600, fontSize: "18px", mb: 0.5 }}>
        You are now in the activation queue.
      </BodyText>
      <SmallText
        sx={{ fontWeight: 500, color: "#888072", fontFamily: "Roboto" }}
      >
        {message}
      </SmallText>
    </div>

    <div style={{}}>
      <SmallText sx={{ mt: 2, px: "5%" }} center>
        This may take up to 4 hours before your device receives service. A
        confirmation will be sent to the email below when completed.
      </SmallText>
      <BodyText center>{email ?? "pramit.paul@yopmail.com"}</BodyText>
    </div>

    <>
      <SmallText
        sx={{
          fontWeight: 500,
          fontSize: "14px",
          fontFamily: "Roboto",
          mt: 2,
          mb: 0,
          color: "#888072",
        }}
        center
      >
        Not activating?
      </SmallText>
      <Button
        variant="text"
        sx={{
          fontWeight: 500,
          fontSize: "14px",
          fontFamily: "Roboto",
          color: "#052B5D",
        }}
        onClick={contactCustomerSupportHandler}
      >
        Contact customer support for assistance.
      </Button>
    </>
  </Paper>
);

export default ActivationPendingView;
